import React from "react"
import type { Locale } from "popopo-msg/routes"
import { SimplePage, PopopoLogoSlant, ActionButton } from "../components"
import { getMessages } from "../messages"

interface BadRequestPageProps {
  locale: Locale
  homeUrl?: string
}

export const BadRequestPage: React.FC<BadRequestPageProps> = ({
  locale,
  homeUrl = "/",
}) => {
  const msg = getMessages(locale)

  return (
    <SimplePage locale={locale}>
      <PopopoLogoSlant color="#E0E0E0" height={80} className="simple-page__logo" />
      <h1 className="simple-page__title">{msg.badRequest.title}</h1>
      <p className="simple-page__description">{msg.badRequest.description}</p>
      <ActionButton href={homeUrl} variant="outlined">
        {msg.badRequest.backButton}
      </ActionButton>
    </SimplePage>
  )
}
